import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { Box, CircularProgress, Typography } from "@mui/material";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";
import { reset as portalReset } from "../../redux/portalSlice";

export default function LogoutRoute() {
    const { logout } = useAuth0();
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            try {
            } finally {
                dispatch(userReset());
                dispatch(insuranceReset());
                dispatch(stripeReset());
                dispatch(portalReset());

                logout({
                    logoutParams: {
                        returnTo: `${window.location.origin}/login`,
                    },
                });
            }
        })();
    }, [dispatch, logout]);

    return (
        <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", textAlign: "center", px: 2 }}>
            <div>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Signing you out…</Typography>
            </div>
        </Box>
    );
}
